"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcButton_1 = require("./AcButton");
var AcNameStamp_module_scss_1 = __importDefault(require("./AcNameStamp.module.scss"));
exports.AcNameStamp = function (_a) {
    var nameCharacter = _a.nameCharacter, inCharge = _a.inCharge, tooltipText = _a.tooltipText, _b = _a.size, size = _b === void 0 ? 30 : _b, handleOnEntered = _a.handleOnEntered, handleOnExited = _a.handleOnExited;
    var stampVariables;
    switch (inCharge) {
        case 'NOT_MINE':
            stampVariables = {
                buttonStyle: 'nameStampNotMine',
            };
            break;
        case 'MINE':
            stampVariables = {
                buttonStyle: 'nameStampMine',
            };
            break;
        case 'NONE':
        default:
            stampVariables = {
                buttonStyle: 'nameStampNone',
            };
            break;
    }
    return (
    // aperza-app-efax is added to implement BS style as tooltip is generate outside #aperza-app-efax
    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { onEntered: handleOnEntered, onExited: handleOnExited, placement: "top", trigger: "hover", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: { zIndex: 101 }, className: "aperza-app", id: "ac-name-stamp-tooltip" }, tooltipText) },
        react_1.default.createElement(AcButton_1.AcButton, { width: size, height: size, variant: "white", className: "p-0 border-2 rounded-full " + AcNameStamp_module_scss_1.default[stampVariables.buttonStyle], tabIndex: -1 },
            react_1.default.createElement("span", { className: "fs-16 m-auto " + AcNameStamp_module_scss_1.default.nameStampText }, nameCharacter))));
};
exports.AcNameStamp.displayName = 'AcNameStamp';
//# sourceMappingURL=AcNameStamp.js.map